enum AgreementsActionTypesEnum {
  SAVE_AGREEMENTS = 'SAVE_AGREEMENTS',
  RESET_AGREEMENTS = 'RESET_AGREEMENTS',
  SAVE_ACCEPTED_AGREEMENTS = 'SAVE_ACCEPTED_AGREEMENTS',
  SET_AGREEMENT_FILTER = 'SET_AGREEMENT_FILTER',
  RESET_AGREEMENT_FILTERS = 'RESET_AGREEMENT_FILTERS',
}

export default AgreementsActionTypesEnum;

